import { render, staticRenderFns } from "./ControleSaldosOrgaoListagem.vue?vue&type=template&id=411e31c3"
import script from "./ControleSaldosOrgaoListagem.vue?vue&type=script&lang=js"
export * from "./ControleSaldosOrgaoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports